import { BaseResource } from '../core/base-resource';

export class PaymentTypeFee extends BaseResource {
  paymentType: string;
  amount: number;
  fee: number;
  paymentFeeName: string;
}
